<template>
	<div class="homePage">
		<!-- 轮播 -->
		<div class="bannerBox flex animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="l">
				<el-carousel height="3.7rem" @change="bannerC" ref="carousel" indicator-position="none" :autoplay="true">
				    <el-carousel-item v-for="(item,index) in bannerList" :key="'b1'+index">
						<el-image @click="wlLink(item.link)" class="icon" fit="cover" :src="item.picture"></el-image>
				    </el-carousel-item>
				</el-carousel>
				<div class="dianBox f-bct" v-if="bannerList.length">
					<p class="line1">{{bannerList[bannerIdx].name}}</p>
					<div class="dian f-ct">
						<div @click="bannerDian(index)" :class="bannerIdx==index?'a':''" v-for="(item,index) in bannerList"></div>
					</div>
				</div>
			</div>
			<div class="r">
				<div class="navBox f-ct">
					<p @click="tzAll=companyNewsList,newsType=1" :class="newsType==1?'a':''">协会通知</p>
					<p @click="tzAll=noticeNewsList,newsType=2" :class="newsType==2?'a':''">通知公告</p>
					<p @click="tzAll=industryNewsList,newsType=3" :class="newsType==3?'a':''">行业动态</p>
					<p @click="tzAll=specialNewsList,newsType=4" :class="newsType==4?'a':''">专题报道</p>
				</div>
				<!-- 协会通知 -->
				<div class="zw" v-if="!tzAll.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<template v-if="tzAll.length">
				<div class="hotNews" @click="goAdetail(tzAll[0].id)">
					<div class="t1 f-ct">
						<el-image v-if="tzAll[0].isHot" :src="require('@/static/icon20.png')"></el-image>
						<p class="line1">{{tzAll[0].title}}</p>
					</div>
					<div class="t2 f-bct">
						<p class="line1">{{tzAll[0].descriptions}}</p>
						<p class="time">{{quSFM(tzAll[0].createTime)}}</p>
					</div>
				</div>
				<div class="newList">
					<div class="item f-bct" @click="goAdetail(item.id)" v-if="index<6" v-for="(item,index) in tzAll">
						<div class="newsIteml f-ct">
							<el-image class="i1" :src="require('@/static/icon19h.png')"></el-image>
							<el-image class="i2" :src="require('@/static/icon19.png')"></el-image>
							<p class="line1">{{item.title}}</p>
						</div>
						<p class="time">{{quSFM(item.createTime)}}</p>
					</div>
				</div>
				</template>
			</div>
		</div>
		<!-- 功能键 -->
		<div class="functionNav f-ct animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<el-image @click="wlLink(item.link)" fit="cover" v-for="item in specialActivityList" :src="item.picture"></el-image>
		</div>
		<!-- 培训课程 -->
		<div class="peixun f-ct animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="title f-bct">
				<div class="l f-ct">
					<div class="bor"></div>
					<div class="t1">培训课程</div>
					<div class="t2">TRAINING COURSES</div>
				</div>
				<div class="more f-ct" @click="link('/study')">
					<p>查看更多</p>
					<el-image :src="require('@/static/icon21.png')"></el-image>
				</div>
			</div>
			<div class="list f-ct">
				<div v-for="(item,index) in courseList">
					<div class="item f-bct" @click="gokcMsg(itm)" v-for="(itm,idx) in item">
						<div class="newsIteml f-ct">
							<el-image class="i1" :src="require('@/static/icon19h.png')"></el-image>
							<el-image class="i2" :src="require('@/static/icon19.png')"></el-image>
							<p class="tips">考前培训</p>
							<p class="line1">{{itm.name}}</p>
							<el-image class="i3" v-if="itm.isHot" :src="require('@/static/icon20.png')"></el-image>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 图 -->
		<div class="ad animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<!-- <el-carousel height="1.2rem" indicator-position="none" :autoplay="true">
			    <el-carousel-item v-for="(item,index) in specialNewsList" :key="'b2'+index">
					<el-image @click="goAdetail(item.id)" class="icon" fit="fill" :src="item.picture"></el-image>
			    </el-carousel-item>
			</el-carousel> -->
			<el-image class="icon" fit="fill" :src="require('@/static/img7.png')"></el-image>
		</div>
		<!-- 技术服务 -->
		<div class="jishu animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="title f-bct">
				<div class="l f-ct">
					<div class="bor"></div>
					<div class="t1">技术服务</div>
					<div class="t2">TECHNICAL SERVICE</div>
				</div>
				<div class="more f-ct" @click="link('/skillList')">
					<p>查看更多</p>
					<el-image :src="require('@/static/icon21.png')"></el-image>
				</div>
			</div>
			<!-- 技术服务 -->
			<div class="jishuCon f-bct">
				<div class="l">
					<p @click="jsfwAll=technicalServiceDsffwNewsList,jishuType=4" :class="jishuType==4?'a':''">第三方服务</p>
					<p @click="jsfwAll=technicalServiceKyktNewsList,jishuType=1" :class="jishuType==1?'a':''">燃气设施推广</p>
					<p @click="jsfwAll=technicalServiceJsjdNewsList,jishuType=2" :class="jishuType==2?'a':''">技术鉴定</p>
					<p @click="jsfwAll=technicalServiceXjstgNewsList,jishuType=3" :class="jishuType==3?'a':''">新技术推广</p>
				</div>
				<div class="r">
					<div class="zw" v-if="!jsfwAll.length">
						<el-image :src="require('@/static/zw.png')"></el-image>
						<p>暂无相关数据...</p>
					</div>
					<div class="itm f-ct" @click="goAdetail(item.id)" v-for="(item,index) in jsfwAll">
						<el-image :src="item.picture"></el-image>
						<div class="itemr">
							<div class="name f-bct">
								<p class="line1">{{item.title}}</p>
								<p class="time">{{quSFM(item.createTime)}}</p>
							</div>
							<div class="detail line2">{{item.descriptions}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 党建工作/安全管理 -->
		<div class="safeOther f-bct animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="r">
				<div class="title f-bct">
					<div class="l f-ct">
						<div class="bor"></div>
						<div class="t1">党建工作</div>
						<div class="t2">PARTY BUILDING WORK</div>
					</div>
					<div class="more f-ct" @click="link('/dangTxt')">
						<p>查看更多</p>
						<el-image :src="require('@/static/icon21.png')"></el-image>
					</div>
				</div>
				<div class="navBox f-ct">
					<p @click="jsdgzAll=foundPartyWorkDdjsNewsList,dangType=1" :class="dangType==1?'a':''">党的建设</p>
					<p @click="jsdgzAll=foundPartyWorkLjwyNewsList,dangType=2" :class="dangType==2?'a':''">廉洁从业</p>
					<p @click="jsdgzAll=foundPartyWorkDykmNewsList,dangType=3" :class="dangType==3?'a':''">党员楷模</p>
				</div>
				<div class="zw" v-if="!jsdgzAll.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="newList">
					<div class="item f-bct" @click="goAdetail(item.id)" v-for="(item,index) in jsdgzAll">
						<div class="newsIteml f-ct">
							<el-image class="i1" :src="require('@/static/icon19h.png')"></el-image>
							<el-image class="i2" :src="require('@/static/icon19.png')"></el-image>
							<p class="line1">{{item.title}}</p>
						</div>
						<p class="time">{{quSFM(item.createTime)}}</p>
					</div>
				</div>
			</div>
			<div class="r">
				<div class="title f-bct">
					<div class="l f-ct">
						<div class="bor"></div>
						<div class="t1">安全管理</div>
						<div class="t2">SAFETY MANAGEMENT</div>
					</div>
					<div class="more f-ct" @click="link('/safetyList')">
						<p>查看更多</p>
						<el-image :src="require('@/static/icon21.png')"></el-image>
					</div>
				</div>
				<div class="navBox f-ct">
					<p @click="aqglAll=safetyManagerAcbdNewsList,safeType=1" :class="safeType==1?'a':''">安全报道</p>
					<p @click="aqglAll=safetyManagerAcbgNewsList,safeType=2" :class="safeType==2?'a':''">安全报告</p>
					<p @click="aqglAll=safetyManagerAckpNewsList,safeType=3" :class="safeType==3?'a':''">安全科普</p>
				</div>
				<div class="zw" v-if="!aqglAll.length">
					<el-image :src="require('@/static/zw.png')"></el-image>
					<p>暂无相关数据...</p>
				</div>
				<div class="newList">
					<div class="item f-bct" @click="goAdetail(item.id)" v-for="(item,index) in aqglAll">
						<div class="newsIteml f-ct">
							<el-image class="i1" :src="require('@/static/icon19h.png')"></el-image>
							<el-image class="i2" :src="require('@/static/icon19.png')"></el-image>
							<p class="line1">{{item.title}}</p>
						</div>
						<p class="time">{{quSFM(item.createTime)}}</p>
					</div>
				</div>
			</div>
		</div>
		<!-- 友情链接 -->
		<div class="links f-ct animate__animated animate__fadeIn" data-wow-duration="0.8s">
			<div class="title f-bct">
				<div class="l f-ct">
					<div class="bor"></div>
					<div class="t1">友情链接</div>
					<div class="t2">FRIENDSHIP LINK</div>
				</div>
			</div>
			<div class="list f-ct">
				<div class="itm f-ct" @click="getNewsDetail(item.url)" v-for="(item,index) in friendlyLinkList">
					<el-image :src="require('@/static/icon22.png')"></el-image>
					<p class="line1">{{item.title}}</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { homeIndex } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			bannerIdx:0,
			newsType:1,
			jishuType:4,
			dangType:1,
			safeType:1,
			// 获取到的数据
			bannerList:[],//轮播1
			specialNewsList:[],//专题报道轮播2
			specialActivityList:[],//五图链接
			// 协会通知 / 通知公告 / 行业动态
			tzAll:[],
			companyNewsList:[],
			noticeNewsList:[],
			industryNewsList:[],
			specialNewsList:[],
			// 课程
			courseList:[],
			// 技术服务
			jsfwAll:[],
			technicalServiceKyktNewsList:[],
			technicalServiceJsjdNewsList:[],
			technicalServiceXjstgNewsList:[],
			technicalServiceDsffwNewsList:[],
			// 建党工作
			jsdgzAll:[],
			foundPartyWorkDdjsNewsList:[],
			foundPartyWorkLjwyNewsList:[],
			foundPartyWorkDykmNewsList:[],
			// 安全管理
			aqglAll:[],
			safetyManagerAcbdNewsList:[],
			safetyManagerAcbgNewsList:[],
			safetyManagerAckpNewsList:[],
			// 友情链接
			friendlyLinkList:[],
		}
	},
	mounted() {
		// 获取首页数据
		this.homeIndex()
	},
	methods:{
		gokcMsg(item){
			if(this.userInfo){
				this.link('/studyMsg',{id:item.id})
			}else{
				this.Tips('请先登录','error')
				setTimeout(()=>{
					this.link('/login')
				},1500)
			}
		},
		// 跳转文章详情
		goAdetail(id){
			this.link('/dynamicMsg',{id})
		},
		// 获取首页数据
		async homeIndex(){
			let res = await homeIndex({});
			if(res.code==200){
				this.bannerList = res.data.bannerList //轮播1
				this.specialNewsList = res.data.specialNewsList //专题报道轮播2
				this.specialActivityList = res.data.specialActivityList //五图链接
				// 协会通知 / 通知公告 / 行业动态
				this.tzAll = res.data.companyNewsList
				this.companyNewsList = res.data.companyNewsList
				this.noticeNewsList = res.data.noticeNewsList
				this.industryNewsList = res.data.industryNewsList
				this.specialNewsList = res.data.specialNewsList
				// 课程
				var arr1 = []
				var arr2 = []
				var isarr1 = true
				res.data.courseList.forEach((item)=>{
					if(isarr1){
						arr1.push(item)
						isarr1 = false
					}else{
						arr2.push(item)
						isarr1 = true
					}
				})
				this.courseList = [arr1,arr2]
				// console.log(this.courseList)
				// 技术服务
				this.jsfwAll = res.data.technicalServiceDsffwNewsList
				this.technicalServiceKyktNewsList = res.data.technicalServiceKyktNewsList
				this.technicalServiceJsjdNewsList = res.data.technicalServiceJsjdNewsList
				this.technicalServiceXjstgNewsList = res.data.technicalServiceXjstgNewsList
				this.technicalServiceDsffwNewsList = res.data.technicalServiceDsffwNewsList
				// 建党工作
				this.jsdgzAll = res.data.foundPartyWorkDdjsNewsList
				this.foundPartyWorkDdjsNewsList = res.data.foundPartyWorkDdjsNewsList
				this.foundPartyWorkLjwyNewsList = res.data.foundPartyWorkLjwyNewsList
				this.foundPartyWorkDykmNewsList = res.data.foundPartyWorkDykmNewsList
				// 安全管理
				this.aqglAll = res.data.safetyManagerAcbdNewsList
				this.safetyManagerAcbdNewsList = res.data.safetyManagerAcbdNewsList
				this.safetyManagerAcbgNewsList = res.data.safetyManagerAcbgNewsList
				this.safetyManagerAckpNewsList = res.data.safetyManagerAckpNewsList
				// 友情链接
				this.friendlyLinkList = res.data.friendlyLinkList
			}else{this.Tips(res.msg,'error')}
		},
		// 轮播图
		bannerC(e){
			this.bannerIdx = e
		},
		bannerDian(index){
			this.$refs.carousel.setActiveItem(index)
		},
		group(array, subGroupLength) {
			let index = 0;
			let newArray = [];
			while(index < array.length) {
				newArray.push(array.slice(index, index += subGroupLength));
			}
			return newArray;
		}
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.bannerBox{
	width: 1200px;
	background: #fff;
	padding: 24px 22px;
	padding-left: 24px;
	margin: auto;
	margin-top: 20px;
	margin-bottom: 20px;
	.l{
		width: 638px;
		height: 370px;
		position: relative;
		margin-right: 24px;
		.dianBox{
			width: 100%;
			height: 54px;
			background: #00000080;
			position: absolute;
			left: 0;
			bottom: 0;
			padding: 0 16px;
			z-index: 10;
			p{
				font-size: 18px;
				color: #FFFFFF;
				width: 500px;
			}
			.dian{
				div{
					width: 8px;
					height: 8px;
					margin-left: 6px;
					background: #D9D9D9;
					border-radius: 50%;
					cursor: pointer;
				}
				.a{
					background: #3B6492;
				}
			}
		}
	}
	.r{
		width: 492px;
		.navBox{
			border-bottom: 1px solid #EEEEEE;
			height: 35px;
			p{
				height: 35px;
				margin-right: 36px;
				font-size: 18px;
				cursor: pointer;
				&::after{
					position: absolute;
					content: '';
					width: 0%;
					height: 2px;
					background: #3B6492;
					left: 50%;
					bottom: 0;
					transform: translateX(-50%);
					transition:0.3s;
				}
			}
			.a{
				color: #3B6492;
				font-weight: bold;
				&::after{
					width: 100%;
					transition:0.3s;
				}
			}
		}
		.hotNews{
			height: 92px;
			padding-top: 21px;
			border-bottom: 1px solid #EEEEEE;
			position: relative;
			cursor: pointer;
			.t1{
				margin-bottom: 10px;
				.el-image{
					width: 20px;
					height: 24px;
					margin-right: 3px;
				}
				p{
					width: calc(100% - 23px);
					font-size: 18px;
				}
			}
			.t2{
				color: #999999;
				.line1{
					width: calc(100% - 105px);
					font-size: 14px;
				}
				.time{
					width: 85px;
					margin-left: 20px;
				}
			}
			&::after{
				width: 26px;
				height: 1px;
				content: '';
				position: absolute;
				bottom: 0;
				left: 0;
				background: #3B6492;
			}
		}
		.newList{
			.item{
				cursor: pointer;
				padding-top: 18px;
				&:hover{
					.newsIteml{
						.i1{
							display: block;
						}
						.i2{
							display: none;
						}
						p{
							color: #3B6492;
						}
					}
				}
				.newsIteml{
					width: calc(100% - 105px);
					.el-image{
						width: 14px;
						height: 14px;
						margin-right: 8px;
					}
					p{
						width: calc(100% - 22px);
						font-size: 14px;
					}
					.i1{
						display: none;
					}
					.i2{
						display: block;
					}
				}
				.time{
					width: 85px;
					font-size: 12px;
					margin-left: 20px;
					color: #999999;
				}
			}
		}
	}
}
.functionNav{
	width: 1200px;
	margin: auto;
	margin-bottom: 20px;
	.el-image{
		width: 228px;
		height: 140px;
		margin-right: 15px;
		&:last-child{
			margin-right: 0;
		}
	}
}
.peixun{
	width: 1200px;
	margin: auto;
	background: #fff;
	margin-bottom: 20px;
	padding: 0 24px;
	.title{
		width: 100%;
		padding-top: 25px;
		padding-bottom: 14px;
		border-bottom: 1px solid #EEEEEE;
		.l{
			.bor{
				width: 3px;
				height: 24px;
				border-radius: 3px;
				background: #3B6492;
				margin-right: 10px;
			}
			.t1{
				font-size: 22px;
				margin-right: 10px;
			}
			.t2{
				font-size: 16px;
				color: #3B6492;
			}
		}
		.more{
			cursor: pointer;
			p{
				font-size: 16px;
				color: #3B6492;
				margin-right: 2px;
			}
			.el-image{
				width: 14px;
				height: 14px;
			}
		}
	}
	.list{
		width: 100%;
		padding-bottom: 28px;
		>div{
			width: 50%;
			&:last-child{
				// padding-left: 20px;
			}
			.item{
				width: 100%;
				cursor: pointer;
				padding-top: 18px;
				&:hover{
					.newsIteml{
						.i1{
							display: block;
						}
						.i2{
							display: none;
						}
						p{
							color: #3B6492;
						}
						.tips{
							border: 1px solid #3B6492;
						}
					}
				}
				.newsIteml{
					// width: calc(100% - 105px);
					width: 100%;
					.el-image{
						width: 14px;
						height: 14px;
						margin-right: 8px;
					}
					.i3{
						width: 15px;
						height: 18px;
						margin-right: 0;
						margin-left: 8rpx;
					}
					p{
						max-width: calc(100% - 140px);
						font-size: 14px;
						margin-right: 10px;
					}
					.tips{
						margin-right: 8px;
						width: 60px;
						height: 24px;
						border: 1px solid #B8BAC3;
						font-size: 12px;
						color: #8E8E99;
						text-align: center;
						line-height: 22px;
						border-radius: 4px;
					}
					.i1{
						display: none;
					}
					.i2{
						display: block;
					}
				}
				.time{
					width: 85px;
					font-size: 12px;
					margin-left: 20px;
					color: #999999;
				}
			}
		}
	}
}
.ad{
	width: 1200px;
	height: 122px;
	margin: auto;
	margin-bottom: 20px;
	.el-image{
		width: 1200px;
		height: 122px;
	}
}
.jishu{
	width: 1200px;
	margin: auto;
	// background: #fff;
	margin-bottom: 20px;
	// padding: 0 24px;
	.title{
		width: 100%;
		height: 56px;
		background: #fff;
		padding: 0 24px;
		// padding-top: 25px;
		// padding-bottom: 14px;
		// border-bottom: 1px solid #EEEEEE;
		.l{
			.bor{
				width: 3px;
				height: 24px;
				border-radius: 3px;
				background: #3B6492;
				margin-right: 10px;
			}
			.t1{
				font-size: 22px;
				margin-right: 10px;
			}
			.t2{
				font-size: 16px;
				color: #3B6492;
			}
		}
		.more{
			cursor: pointer;
			p{
				font-size: 16px;
				color: #3B6492;
				margin-right: 2px;
			}
			.el-image{
				width: 14px;
				height: 14px;
			}
		}
	}
	.jishuCon{
		// background: #fff;
		margin-top: 20px;
		align-items: stretch;
		.l{
			width: 219px;
			// height: 485px;
			background: #fff;
			padding: 0 24px;
			p{
				height: 62px;
				line-height: 62px;
				font-size: 16px;
				cursor: pointer;
				border-bottom: 1px dashed #BBBBBB
			}
			.a{
				color: #3B6492;
				font-weight: bold;
			}
		}
		.r{
			width: 961px;
			// height: 485px;
			padding: 0 24px;
			background: #fff;
			padding-bottom: 20px;
			.itm{
				padding: 20px 0;
				cursor: pointer;
				border-bottom: 1px solid #EEEEEE;
				&:last-child{
					border-bottom: 0;
				}
				.el-image{
					width: 132px;
					height: 78px;
					border-radius: 4px;
					margin-right: 16px;
				}
				.itemr{
					width: calc(100% - 148px);
					.name{
						.line1{
							width: calc(100% - 105px);
							font-size: 16px;
							font-weight: bold;
						}
						.time{
							width: 105px;
							font-size: 14px;
						}
					}
					.detail{
						margin-top: 8px;font-size: 14px;
						color: #999999;
					}
				}
			}
		}
	}
}
.safeOther{
	width: 1200px;
	margin: auto;
	margin-top: 20px;
	margin-bottom: 20px;
	align-items: stretch;
	.r{
		width: 590px;
		padding: 0 24px;
		background: #fff;
		.title{
			width: 100%;
			// height: 56px;
			padding-top: 25px;
			padding-bottom: 14px;
			// background: #fff;
			// padding: 0 24px;
			// padding-top: 25px;
			// padding-bottom: 14px;
			border-bottom: 1px solid #EEEEEE;
			.l{
				.bor{
					width: 3px;
					height: 24px;
					border-radius: 3px;
					background: #3B6492;
					margin-right: 10px;
				}
				.t1{
					font-size: 22px;
					margin-right: 10px;
				}
				.t2{
					font-size: 16px;
					color: #3B6492;
				}
			}
			.more{
				cursor: pointer;
				p{
					font-size: 16px;
					color: #3B6492;
					margin-right: 2px;
				}
				.el-image{
					width: 14px;
					height: 14px;
				}
			}
		}
		.navBox{
			// border-bottom: 1px solid #EEEEEE;
			// height: 35px;
			padding: 20px 0;
			padding-bottom: 10px;
			p{
				height: 35px;
				margin-right: 18px;
				font-size: 18px;
				cursor: pointer;
				padding-right: 18px;
				&::after{
					position: absolute;
					content: '';
					width: 1px;
					height: 16px;
					background: #DBDBDB;
					top: 50%;
					right: 0;
					transform: translateY(-80%);
				}
				&:last-child{
					&::after{
						display: none;
					}
				}
			}
			.a{
				color: #3B6492;
				font-weight: bold;
			}
		}
		.newList{
			.item{
				cursor: pointer;
				padding-top: 2px;
				padding-bottom: 20px;
				&:hover{
					.newsIteml{
						.i1{
							display: block;
						}
						.i2{
							display: none;
						}
						p{
							color: #3B6492;
						}
					}
				}
				.newsIteml{
					width: calc(100% - 105px);
					.el-image{
						width: 14px;
						height: 14px;
						margin-right: 8px;
					}
					p{
						width: calc(100% - 22px);
						font-size: 14px;
					}
					.i1{
						display: none;
					}
					.i2{
						display: block;
					}
				}
				.time{
					width: 85px;
					font-size: 12px;
					margin-left: 20px;
					color: #999999;
				}
			}
		}
	}
}
.links{
	width: 1200px;
	margin: auto;
	background: #fff;
	margin-bottom: 20px;
	padding: 0 24px;
	.title{
		width: 100%;
		padding-top: 25px;
		padding-bottom: 14px;
		border-bottom: 1px solid #EEEEEE;
		.l{
			.bor{
				width: 3px;
				height: 24px;
				border-radius: 3px;
				background: #3B6492;
				margin-right: 10px;
			}
			.t1{
				font-size: 22px;
				margin-right: 10px;
			}
			.t2{
				font-size: 16px;
				color: #3B6492;
			}
		}
	}
	.list{
		width: 100%;
		padding-top: 24px;
		.itm{
			width: calc(100% / 3);
			margin-bottom: 18px;
			padding-right: 10px;
			.el-image{
				width: 10px;
				height: 10px;
				margin-right: 5px;
			}
			p{
				font-size: 16px;
				text-align: justify;
				// text-align-last:justify;
				width: calc(100% - 15px);
			}
			&:hover{
				p{
					color: #3B6492;
				}
			}
		}
	}
}
</style>